document.addEventListener("alpine:init", () => {
    Alpine.data("scrollSwitcherResultsWrapper", () => ({
        id: null,
        secondaryItems: null,
        init() {
            this.secondaryItems = this.$el.querySelectorAll(
                ".Pegasus__Container"
            );

            window.addEventListener("pegasus-ss-item-selected", (event) => {
                this.id = event.detail.id;

                this.secondaryItems.forEach((element) => {
                    if (this.id === element.id) {
                        element.classList.add("-active");
                    } else {
                        element.classList.remove("-active");
                    }
                });
            });
        },
    }));
});
